module.exports = __webpack_public_path__ + "img/concreted_unstabilized.1134de6a.png";